// generated file with usage count of color found in the undraw directory
export default {
  707070: 2,
  f2f2f2: 4,
  ed9da0: 12,
  "6c63ff": 22,
  "3f3d58": 4,
  "090814": 13,
  d6d6e3: 3,
  e6e6e6: 18,
  "2f2e41": 12,
  "3f3d56": 6,
  a0616a: 7,
  ffb6b6: 3,
};
